import { useState, useEffect, useContext, useCallback } from 'react'
import { AppContext } from '../../contexts'
import { getClientTokenFromStorage } from '../../storage'
import { useIsExtension } from '../utility'
import { GUEST_CLIENT_TYPE } from '../../constants/buyerSettings'

export const BEARER_PREFIX = 'Bearer'
export const CUSTOMER_PUBLIC_KEY_PREFIX = 'hb-cust-pub'

export const useAuthSettings = () => {
  const {
    customerPublicKey,
    clientAuthToken: clientTokenFromContext,
    clientType,
  } = useContext(AppContext)
  const isExtension = useIsExtension()

  const [authSettings, setAuthSettings] = useState(null)

  const establishAuthorizationScheme = useCallback(async () => {
    const clientTokenFromStorage = await getClientTokenFromStorage()

    if (isExtension) {
      if (!clientTokenFromStorage) {
        setAuthSettings({
          scheme: null,
          token: null,
        })
      } else {
        setAuthSettings({
          scheme: BEARER_PREFIX,
          token: clientTokenFromStorage,
        })
      }
    } else {
      if (!customerPublicKey) {
        // TODO: this will allow requests to fire and authenticated endpoints will fail,
        // however our auth error is fairly extension specific as it stands
        setAuthSettings({
          scheme: null,
          token: null,
        })
      } else if (clientTokenFromContext && clientType !== GUEST_CLIENT_TYPE) {
        setAuthSettings({
          scheme: BEARER_PREFIX,
          token: clientTokenFromContext,
        })
      } else {
        setAuthSettings({
          scheme: CUSTOMER_PUBLIC_KEY_PREFIX,
          token: customerPublicKey,
        })
      }
    }
  }, [clientTokenFromContext, clientType, customerPublicKey, isExtension])

  useEffect(() => {
    establishAuthorizationScheme()
    window.addEventListener('visibilitychange', establishAuthorizationScheme)

    return () =>
      window.removeEventListener(
        'visibilitychange',
        establishAuthorizationScheme
      )
  }, [establishAuthorizationScheme])

  return authSettings
}
